<header></header> <menu></menu> <main> <router-outlet></router-outlet> </main> <big-border></big-border> 